import Vue from 'vue';
export default Vue.extend({
    name: 'whitelistsItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        resolvedNetworkData() {
            const isAdded = Boolean(this.item.network);
            const isIncorrect = !this.item.isValidAddress && this.item.isValidAddress !== null;
            return {
                isAdded: isAdded,
                isIncorrect: isIncorrect,
                text: isIncorrect
                    ? 'Некорректный адрес'
                    : !isAdded
                        ? 'Добавить сеть'
                        : this.item.network
            };
        },
        computedAddress() {
            if (this.item.address && this.item.addressVisible)
                return this.item.address;
            return this.item.blurredAddress ? this.item.blurredAddress : '*******************************';
        }
    }
});
